module.exports = "/_next/static/images/offers5-8e3f3316b8a5c98255a889755f953fbd.jpg.webp";